
      // Function to gather form data into an object
      function collectFormData() {
        const formDataArray = [
          ['HighBP', document.getElementById('high-bp-select').value],
          ['HighChol', document.getElementById('high-cholesterol-select').value],
          ['CholCheck', document.getElementById('cholesterol-test-select').value],
          ['BMI', document.getElementById('bmi-input').value],
          ['Smoker', document.getElementById('smoking-select').value],
          ['Stroke', document.getElementById('stroke-select').value],
          ['HeartDiseaseorAttack', document.getElementById('chd-select').value],
          ['PhysActivity', document.getElementById('physical-activities-range').value],
          ['Fruits', document.getElementById('fruit-consume-select').value],
          ['Veggies', document.getElementById('vegetables-consume-select').value],
          ['HvyAlcoholConsump', document.getElementById('heavy-drinker-select').value],
          ['GenHlth', document.getElementById('general-health-select').value],
          ['MentHlth', document.getElementById('mental-health-issues-range').value],
          ['PhysHlth', document.getElementById('physical-health-illness-range').value],
          ['DiffWalk', document.getElementById('difficulty-walking-select').value],
          ['Age', document.getElementById('age-select').value],
          ['Education', document.getElementById('education-level-select').value],
          ['Income', document.getElementById('income-level-select').value]
        ]

        return Object.fromEntries(formDataArray)
      }

      // Event listener for Submit button click
      document.getElementById('submit-btn').addEventListener('click', () => {
        const formData = collectFormData()

        // Convert form data into query parameters
        const queryParams = new URLSearchParams(formData).toString()
        console.log(queryParams)

        // Send GET request with query parameters to the backend
        const url = `https://diabetes-prediction-b5t0.onrender.com/submit-data?${queryParams}`

        fetch(url, {
          method: 'GET'
        })
          .then((response) => response.json())
          .then((data) => {
            console.log('Success:', data)

            const resultUrl = `result.html?data=${encodeURIComponent(JSON.stringify(data))}`
            window.location.href = resultUrl
          })
          .catch((error) => {
            console.error('Error:', error)
          })
      })

      // Script to update range value text
      document.getElementById('physical-activities-range').addEventListener('input', function () {
        document.getElementById('physical-activities-value').textContent = this.value
      })

      document.getElementById('mental-health-issues-range').addEventListener('input', function () {
        document.getElementById('mental-health-issues-value').textContent = this.value
      })

      document.getElementById('physical-health-illness-range').addEventListener('input', function () {
        document.getElementById('physical-health-illness-value').textContent = this.value
      })
    